import { createContext, ReactNode, useEffect, useState } from 'react'
import { Configuration } from '../Interfaces/configuration'
import { Notifications } from '../Interfaces/notifications'
import { api } from '../services/api'
import { useAuth } from './AuthContext'

type ConfigurationData = {
  configuration: Configuration
  notifications: Notifications[]
  populateNotifications: (notifications: Notifications[]) => void
}

type Props = {
  children: ReactNode
}

export const ConfigurationContext = createContext({} as ConfigurationData)

export const ConfigurationProvider = ({ children }: Props) => {
  const [configuration, setConfiguration] = useState<Configuration>()
  const [notifications, setNotifications] = useState<Notifications[]>([])
  const { user } = useAuth()

  useEffect(() => {
    let isMounted = true

    const loadConfig = async () => {
      try {
        const { data } = await api.get(`configurations/last-update`)

        // A API retorna um único objeto. Mantém compatibilidade caso venha array.
        const cfg = Array.isArray(data) ? data[0] : data

        if (isMounted) {
          setConfiguration(cfg as Configuration)
        }
      } catch (err) {
        console.error('Servidor não encontrado')
        // Evita undefined no consumer
        if (isMounted) {
          setConfiguration({
            max_order_days: 0,
            oven_burn_value: 0,
            oven_parts: 0,
            work_hour_value: 0,
            printer_name: '',
          } as Configuration)
        }
      }
    }

    loadConfig()

    return () => {
      isMounted = false
    }
  }, [user])

  const populateNotifications = (notifications: Notifications[]) => {
    setNotifications(notifications)
  }

  return (
    <ConfigurationContext.Provider value={{ configuration, notifications, populateNotifications }}>
      {children}
    </ConfigurationContext.Provider>
  )
}
